"use client";

import { productAnalytics } from "@/utils/productAnalytics/client";
import type { AuthEventPropertyMap } from "@/utils/productAnalytics/events/auth";
import { trackSystemLogSimple } from "@/utils/systemLogs/trackSystemLogSimple";
import { z } from "zod";

export function trackAuthFormSubmit({
  input,
  action,
}: {
  input: string;
  action: AuthEventPropertyMap["auth.form.submitted"]["action"];
}) {
  const email = z.string().trim().email().max(254).safeParse(input);
  const properties = {
    action,
    ...(email.success ? { email: email.data.toLowerCase() } : {}),
  };
  try {
    trackSystemLogSimple.info({
      event: "auth.form.submitted",
      data: properties,
    });
    productAnalytics.trackClient({
      event: "auth.form.submitted",
      properties,
      viewerKind: "anonymous",
    });
  } catch {
    // Telemetry must not prevent sign-in.
  }
}
